export const c_truncate = {
  ".pf-c-truncate": {
    "c_truncate_MinWidth": {
      "name": "--pf-c-truncate--MinWidth",
      "value": "12ch"
    },
    "c_truncate__start_MinWidth": {
      "name": "--pf-c-truncate__start--MinWidth",
      "value": "6ch"
    }
  }
};
export default c_truncate;